module.exports = __webpack_public_path__ + "static/media/datasource.56a2d940.svg";